import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["top", "portalHeader", "resourceTitle"]

  initialize() {
    this.topTargets.forEach(target => target.classList.remove("embed-mode-slide"))
  }

  connect() {
    const observer = new IntersectionObserver(
      this.handleMovingCustomTopBody.bind(this)
    )
    observer.observe(this.topTarget)

    this.#adaptBodyTopCSSVar()
  }

  #adaptBodyTopCSSVar = () => {
    const topBar = this.topTarget
    if (topBar) {
      const height = topBar.offsetHeight
      document.documentElement.style.setProperty("--embed-body-top", `${height}px`)
      if (topBar.classList.contains("embed-mode-sticky")) {
        document.documentElement.style.setProperty("--body-top", `${height}px`)
      }
      this.dispatch("bodyTopChange")
    }
  }

  handleMovingCustomTopBody(entries) {
    if (!entries[0].isIntersecting) {
      this.#displayLogo()
    } else {
      this.#hideLogo()
    }
  }

  #displayLogo() {
    if (this.hasResourceTitleTarget) {
      this.resourceTitleTarget.classList.remove("hidden")
    }
  }

  #hideLogo() {
    if (this.hasResourceTitleTarget) {
      this.resourceTitleTarget.classList.add("hidden")
    }
  }
}
